import React, {Component} from 'react';
import PropTypes from "prop-types";
import Api from "../../utils/Api";
import Select from 'react-select';
import StaticFunctions from "../../utils/StaticFunctions";

class UserSettingsContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        timezones: PropTypes.array.isRequired,
        requestUserData: PropTypes.func.isRequired,
    };

    constructor(props) {

        super(props);

        this.api = new Api();

        this.state = {
            editMode: false,
            inputError: [],
            inputParams: {
                id: props.baseData.userData.id,
                email: props.baseData.userData.email,
                firstName: props.baseData.userData.first_name,
                lastName: props.baseData.userData.last_name,
                language: this.props.baseData.i18n.language,
                timezone: props.baseData.userData.timezone,
            },
            cancelParams: {
                id: props.baseData.userData.id,
                email: props.baseData.userData.email,
                firstName: props.baseData.userData.first_name,
                lastName: props.baseData.userData.last_name,
                language: this.props.baseData.i18n.language,
                timezone: props.baseData.userData.timezone,
            },
        };

        this.translate = this.props.baseData.translate;

        this.resetInput = this.resetInput.bind(this);
        this.setInputError = this.setInputError.bind(this);
        this.resetInputError = this.resetInputError.bind(this);
        this.saveSettings = this.saveSettings.bind(this);
        this.toggleMode = this.toggleMode.bind(this);
        this.saveOldParams = this.saveOldParams.bind(this);

    }

    moveCursorToEnd(field) {

        const temp_value = field.target.value;

        field.target.value = '';
        field.target.value = temp_value;

    }

    editInput(event, key) {

        const newInput = {...this.state.inputParams};

        newInput[key] = event.target.value;

        this.setState({
            inputParams: newInput
        });

    }

    editSelect(event, key) {

        if (!event || key === null) return null;

        const newInput = {...this.state.inputParams};

        newInput[key] = event.value;

        this.setState({
            inputParams: newInput
        });

    }

    resetInput() {

        this.props.requestUserData();

    }

    enterSaveSettings(event) {

        if (event.keyCode === 13) {
            this.saveSettings();
        } else if (event.keyCode === 27) {
            this.toggleMode();
        }

    }

    saveSettings() {

        let input = this.state.inputParams;

        if (input && input.id) {
            let params = {
                action: 'saveSettings',
                id: input.id,
                email: input.email,
                firstName: input.firstName,
                lastName: input.lastName,
                language: input.language,
                timezone: input.timezone,
            };

            let callback = function (res) {
                if (res.success) {
                    this.saveOldParams();
                    this.resetInput();
                    this.toggleMode();
                } else {
                    this.setInputError(res.errors);
                }
            }.bind(this);

            this.api.request('SaveUserSettings', params, callback, null);
        }

    }

    setInputError(errorFields) {

        this.setState({
            inputError: errorFields,
        });

    }

    resetInputError() {

        this.setState({
            inputError: [],
        });

    }

    enterToggleMode(event) {

        if (event.keyCode === 13 || event.keyCode === 27) {
            this.toggleMode();
        }

    }

    toggleMode() {

        if (this.state.editMode) this.setState({inputParams: {...this.state.cancelParams}});

        this.setState({
            editMode: !this.state.editMode,
            inputError: [],
        });

    }

    saveOldParams() {

        this.props.baseData.i18n.changeLanguage(this.state.inputParams.language);

        this.setState({cancelParams: {...this.state.inputParams}});

    }

    checkInputError(fieldName) {

        let result = 'ok';

        if (this.state.inputError) {
            let errorList = this.state.inputError;

            if (errorList.indexOf(fieldName) >= 0) result = 'error';
        }

        return result;

    }


    getLanguages() {

        return (this.props.baseData.languages) ?  this.props.baseData.languages.getLanguageOptions() : [];

    }

    getNameBlock() {

        if (this.state.editMode) {
            return (
                <span>
                    <input name="firstName"
                           className={this.checkInputError('firstName')}
                           type="text"
                           tabIndex="1"
                           value={this.state.inputParams.firstName}
                           autoFocus={true}
                           onFocus={(event) => this.moveCursorToEnd(event)}
                           disabled={false}
                           style={{marginRight: 8, width: 126}}
                           onChange={(event) => this.editInput(event, 'firstName')}
                           onKeyDown={(event) => this.enterSaveSettings(event)}
                    />

                    <input name="lastName"
                           className={this.checkInputError('lastName')}
                           type="text"
                           tabIndex="2"
                           value={this.state.inputParams.lastName}
                           disabled={false}
                           style={{width: 126}}
                           onChange={(event) => this.editInput(event, 'lastName')}
                           onKeyDown={(event) => this.enterSaveSettings(event)}
                    />
                </span>
            );
        } else {
            return (
                <input name="name"
                       type="text"
                       tabIndex="1"
                       value={this.state.inputParams.firstName + ' ' + this.state.inputParams.lastName}
                       disabled={true}
                />
            );
        }

    }

    getButtons() {

        if (this.state.editMode) {
            return (
                <span>
                    <a className="formButton" tabIndex="6" onClick={() => this.toggleMode()} onKeyDown={(event) => this.enterToggleMode(event)}>
                        {this.translate('cancel')}
                    </a>

                    <a className="formButton" tabIndex="7" onClick={() => this.saveSettings()} onKeyDown={(event) => this.enterSaveSettings(event)}>
                        {this.translate('save')}
                    </a>
                </span>
            );
        } else {
            return (
                <span>
                    <a className="formButton" tabIndex="6" onClick={() => this.toggleMode()} onKeyDown={(event) => this.enterToggleMode(event)}>
                        {this.translate('edit')}
                    </a>
                </span>
            );
        }

    }

    getTimezones() {

        return this.props.timezones.map((tz) => {
            let gmt = StaticFunctions.getGmtFromTimezoneString(tz);
            let label = tz + ((gmt) ? ' ' + gmt : '');

            return {
                label: label,
                value: tz
            }
        });

    }

    render() {

        const disabled = !this.state.editMode;
        const languages = this.getLanguages();
        const timezones = this.getTimezones();
        const nameBlock = this.getNameBlock();
        const buttons = this.getButtons();
        const selectedLanguage = languages.find(o => o.value === this.state.inputParams.language) || null;
        const selectedTimezone = timezones.find(o => o.value === this.state.inputParams.timezone) || null;

        return (
            <div className="formSettings">
                <nav>
                    <h1>{this.translate('userSettings')}</h1>
                </nav>

                <div className="formRow">
                    <table>
                        <tbody>
                            <tr>
                                <td className="text-left labelSpan">{this.translate('loginEmail')}</td>

                                <td className="text-left">
                                    <input
                                        name="email"
                                        className={this.checkInputError('email')}
                                        type="text"
                                        tabIndex="3"
                                        value={this.state.inputParams.email}
                                        disabled={true}
                                    />
                                </td>
                            </tr>

                            <tr>
                                <td className="text-left labelSpan">{this.translate('firstLastName')}</td>

                                <td className="text-left">
                                    {nameBlock}
                                </td>
                            </tr>

                            <tr>
                                <td className="text-left labelSpan">{this.translate('language')}</td>

                                <td className="text-left">
                                    <Select
                                        name="language"
                                        placeholder={this.translate('select') + '...'}
                                        className={['chosen-container', 'chosen-container-single', this.checkInputError('language')].join(' ').trim()}
                                        style={{width: '260px'}}
                                        options={languages}
                                        tabIndex="4"
                                        value={selectedLanguage}
                                        isClearable={false}
                                        noOptionsMessage={() => this.translate('noResultsFound')}
                                        isDisabled={disabled}
                                        onChange={(event) => this.editSelect(event, 'language')}
                                    />
                                </td>
                            </tr>

                            <tr>
                                <td className="text-left labelSpan">{this.translate('timezone')}</td>

                                <td className="text-left">
                                    <Select
                                        name="timezone"
                                        placeholder={this.translate('select') + '...'}
                                        className={['chosen-container', 'chosen-container-single', this.checkInputError('timezone')].join(' ').trim()}
                                        style={{width: '260px'}}
                                        options={timezones}
                                        tabIndex="5"
                                        value={selectedTimezone}
                                        isClearable={false}
                                        noOptionsMessage={() => this.translate('noResultsFound')}
                                        isDisabled={disabled}
                                        onChange={(event) => this.editSelect(event, 'timezone')}
                                    />
                                </td>
                            </tr>

                            <tr>
                                <td className="text-left labelSpan webElement">&nbsp;</td>

                                <td className="text-left">{buttons}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );

    }

}

export default UserSettingsContainer;
